import React from 'react'
import { CheckmarkCircle20Filled } from "@fluentui/react-icons";
import { BusinessStatus } from "enum/common";
interface IRegisteredBusinessPlansProps {
  businessStatus?:BusinessStatus;
}
const RegisteredBusinessPlans = ({businessStatus}:IRegisteredBusinessPlansProps) => {
  const businessStatusText = React.useMemo(() => {
    switch (businessStatus) {
      case BusinessStatus.ACTIVATED:
        return <span className="font-medium text-base text-green">Active</span>;
      default:
        return (
          <span className="font-medium text-base text-failed">Not Active</span>
        );
    }
  }, [businessStatus]);
  return (
    <div>
      {" "}
      <div className="text-navyBlue text-xl font-semibold  p-4 bg-white flex w-full md:flex-row flex-col rounded-lg ">
        <div className="flex-1">List your business on Open Rewards</div>
        <div className="text-darkBlue text-base flex gap-1 flex-row items-center">
          {businessStatus === BusinessStatus.ACTIVATED && <CheckmarkCircle20Filled
            color="green"
            className="self-center mb-[2px] md:mt-[2px]"
          />}
          <span className="text-black opacity-60 md:hidden">Status: </span>
          <div className="text-green font-mediun self-end justify-end">
            {businessStatusText}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisteredBusinessPlans;
